var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticStyle:{"margin-top":"50px"}},[(this.$route.params.page2 == 'nodes')?_c('nodes'):(this.$route.params.page2 == 'services')?_c('services'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }